<template>
	<div>
		<CommonHeader :setOrden="true" :showBackButton="true" :showIcon="true" :title="$t('RecoverPassword')"></CommonHeader>

		<div class="content-title">
			<p>{{$t('RecoverPassword')}}</p>
		</div>

		<div class="content">
			<p>{{$t('emailAssociated')}}</p>
			<form class="form-crear">
				<div class="form-group">
					<label>{{$t('email')}}</label>
					<input :placeholder="$t('email')" v-model="email"/>
				</div>
				<!-- :class="{ 'error': error }" -->
				<p v-show="error" class="error"> {{$t('emailNotIdentify')}}</p>
			</form>

			<div id="progress">
				<AjaxButton
						class="final-button"
						:text="check ? $t('emailSent') : $t('RecoverPassword')"
						@click="recoverPassword()"
				></AjaxButton>
			</div>

			<p v-show="check" class="check">{{$t('checkEmail')}}</p>
		</div>
	</div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import CommonHeader from '@/components/CommonHeader.vue'
import AjaxButton from '@/components/AjaxButton.vue'
import auth from '@/config/auth'

@Component({
	components: {
		CommonHeader,
		AjaxButton,
	},
})
export default class WrongPassword extends Vue {
	error = false
	check = false
	email = ''

	async recoverPassword(){
		if(this.email != ''){
			await auth.sendPasswordResetEmail(this.email)
			this.check = true
		}
	}
}
</script>
<style lang="scss" scoped>
p {
	margin: 0;
}
.content-title {
	padding: 1em;
	p {
		color: rgba(254, 202, 56, 1);
		font-weight: bold;
		font-size: 2em;
	}
}
.content {
	padding: 1em;
	p {
		color: rgba(0, 0, 0, 1);
		font-size: 1.2em;
		line-height: 21.5px;
	}
	.form-crear {
		label {
			font-size: 1em;
			color: #000;
			margin-bottom: 0.4em;
		}
		.form-group {
			display: grid;
			margin: 1em 0;

			input {
				border-radius: 7px;
				border: 0.5px solid rgba(192, 192, 192, 1);
				padding: 0.8em 0.8em 0.8em 10px;
				background: url('../assets/icons/check.svg') no-repeat 7px 7px;
			}
			input::-webkit-input-placeholder {
				color: rgba(117, 112, 112, 1);
				font-size: 1.2em;
			}
		}
	}
	#progress {
		width: 100%;
		height: 46px;
		position: relative;
		background: rgba(254, 202, 56, 1);
		border: 1px solid #feca38;
		box-sizing: border-box;
		border-radius: 6px;
		margin: 0.5em 0;
	}

	#percent {
		position: absolute;
		left: 0;
		top: 10px;
		right: 0;
		bottom: 10px;
		text-align: center;
		z-index: 10;
		opacity: 1;
		color: white;
		font-style: normal;
		font-weight: 500;
		font-size: 18px;
		line-height: 27px;
	}

	#bar {
		height: 100%;
		background: #27ae60;
		// Propiedad que define el progreso de la barra
		width: 50%;
	}

	.error {
		color: #eb5757;
		font-size: 16px;

		&:before {
			content: '\f057';
			font-family: FontAwesome;
			margin-right: 5px;
		}
	}

	.check {
		color: rgba(39, 174, 96, 1);
		font-size: 16px;
		text-align: center;
		&:before {
			content: '\f058';
			font-family: FontAwesome;
			margin-right: 5px;
		}
	}
}
</style>
